





















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState,AppSettings } from '../../store';
import VueElementLoading from 'vue-element-loading';
import {RotateSquare2} from 'vue-loading-spinner';
import { mapState } from 'vuex';

@Component({  
  components: {
      RotateSquare2,VueElementLoading
},
computed: {
...mapState({
  'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
  'FavoirteContact_List': (state: StoreState) =>state.dashboard.FavoirteContact_List,
  'FavoirteContact_Count': (state: StoreState) => state.dashboard.FavoirteContact_Count,
  'PersonalContact_List': (state: StoreState) => state.dashboard.PersonalContact_List,
  'PersonalContact_Count': (state: StoreState) => state.dashboard.PersonalContact_Count,
  'contactsidebar_status': (state: StoreState) =>state.dashboard.contactsidebar_status,
  'contact_modalstatus': (state: StoreState) =>state.dashboard.contact_modalstatus,
  
})
},
	mounted(){
    console.log('contact_modalstatus',(this as any).contact_modalstatus);
		 this.$data.message="";
      this.$data.totalcharacter=0;
	},
  
})
export default class CONTACTCRUD extends Vue {
   @Prop()
    public multipleselect;
 
 data() {
   return {
    is_loading: false,
    selectedDevice: null,
    totalcharacter:0,
    message: "",
    char_max_length:AppSettings.MESSAGE_CHAR_LIMIT,
   }
  }

  	created() { 
      this.$data.message="";
      this.$data.totalcharacter=0;
    }
  
  charCount(){
    this.$data.totalcharacter = this.$data.message.length;
  }
   
  DeleteContact1(){
      this.$data.is_loading=true;
      if(this.$props.multipleselect!=undefined &&  this.$props.multipleselect.length!=0){
        this.$data.is_loading=false;
        this.$store.commit('CONTACT_MODAL_STATSUS','');
       //this.$emit('deletecontacevent','delete');
       this.$emit('refreshlist','refresh_listdata');
      } else {
      this.$store.commit('CONTACT_MODAL_STATSUS','');
        this.$data.is_loading=false;
        //this.$emit('deletecontacevent','delete');
         this.$emit('refreshlist','refresh_listdata');
      }

  }
  DeleteContact(){
    
    if(this.$props.multipleselect!=undefined &&  this.$props.multipleselect.length!=0){
      let contactdata = []
      this.$props.multipleselect.forEach(element => {
        if(!element.comanycontact_id) {
              var data=element;
            this.$data.is_loading=true;
     
          var favorite_exist=data.pvt_cont?(this as any).FavoirteContact_Count-1:(this as any).FavoirteContact_Count;
          let fav_exist=(this as any).PersonalContact_List.length-1;
          let personal_count=data.pvt_cont?(this as any).PersonalContact_List.length-1:(this as any).PersonalContact_List.length;
       
        this.$store.dispatch('deleteContact', { id: data._id, rev:data._rev})
                .then(r => {
                    this.$data.is_loading=false;
                    this.$store.commit('SET_MULTIPLEDELETE',false);
                    this.$store.commit('CONTACT_MODAL_STATSUS','');
                    this.$emit('refreshlist','refresh_listdata');
                    this.$emit('deletecontacevent','delete');
                  })
                  .catch(() => {  this.$data.is_loading=false; });
               
          }
      });
    }
    else{
      //single delete
    var data=(this as any).selectedContact;
     this.$data.is_loading=true;
     
     var favorite_exist=data.pvt_cont?(this as any).FavoirteContact_Count-1:(this as any).FavoirteContact_Count;
       let fav_exist=(this as any).PersonalContact_List.length-1;
       let personal_count=data.pvt_cont?(this as any).PersonalContact_List.length-1:(this as any).PersonalContact_List.length;
       
      this.$store.dispatch('deleteContact', { id: data._id, rev:data._rev})
     .then(r => {
        this.$data.is_loading=false;

      /* when u deleting contact from personal or shared ,if in case the deleting contact is favorite , 
         i)Count of favorite has to reduce 
      */
      //this.$store.commit('FAVORITECONTACT_COUNT',favorite_exist);
   //   this.$store.commit('PERSONALCONTACT_COUNT',personal_count);
      this.$store.commit('CONTACT_MODAL_STATSUS','');
       this.$emit('refreshlist','refresh_listdata');
      this.$emit('deletecontacevent','delete');
      
      })
      .catch(() => {  this.$data.is_loading=false; });
     }
   
  }

  close_gropchat(){
    this.$store.commit('CONTACT_MODAL_STATSUS','');
  }

}
